module.exports = __webpack_public_path__ + "img/132x132_weixiu@2x.aaf002c3.png";